import { useState } from 'react';
import { RECENT_SORT_OPTION } from './useSourcesFilters';
import type { SortDirection, SortField } from './useSourcesFilters';

export type FolderSortField = SortField | 'sourceCount';

export interface FolderSortOption {
    field: FolderSortField;
    direction: SortDirection;
}

export const FOLDER_SORT_OPTIONS: {
    id: string;
    field: FolderSortField;
    direction: SortDirection;
    labelKey: string;
}[] = [
    {
        id: 'createdAt-desc',
        field: 'createdAt',
        direction: 'desc',
        labelKey: 'folders.sortLastCreated',
    },
    {
        id: 'name-asc',
        field: 'name',
        direction: 'asc',
        labelKey: 'folders.sortTitleAsc',
    },
    {
        id: 'name-desc',
        field: 'name',
        direction: 'desc',
        labelKey: 'folders.sortTitleDesc',
    },
    {
        id: 'sourceCount-desc',
        field: 'sourceCount',
        direction: 'desc',
        labelKey: 'folders.sortSourceCountDesc',
    },
    {
        id: 'sourceCount-asc',
        field: 'sourceCount',
        direction: 'asc',
        labelKey: 'folders.sortSourceCountAsc',
    },
];

export const DEFAULT_FOLDER_SORT: FolderSortOption = RECENT_SORT_OPTION;

export function toOrderByParam(sortOption: FolderSortOption): string {
    return `${sortOption.field} ${sortOption.direction}`;
}

interface FolderSortState {
    myFoldersSort: FolderSortOption;
    setMyFoldersSort: (option: FolderSortOption) => void;
    sharedFoldersSort: FolderSortOption;
    setSharedFoldersSort: (option: FolderSortOption) => void;
}

export function useFolderSort(): FolderSortState {
    const [myFoldersSort, setMyFoldersSort] =
        useState<FolderSortOption>(DEFAULT_FOLDER_SORT);
    const [sharedFoldersSort, setSharedFoldersSort] =
        useState<FolderSortOption>(DEFAULT_FOLDER_SORT);

    return {
        myFoldersSort,
        setMyFoldersSort,
        sharedFoldersSort,
        setSharedFoldersSort,
    };
}
